'use strict';
(function(angular) {
  angular.module('fetchtv.Directives')
    .directive('ftOutageNotification', function() {
      return {
        restrict: 'E',
        replace: true,
        scope: {
          blockerNotificationDetected:'=' /*danger,info, none*/,
          appName:'@'
        },
        templateUrl: 'views/common/outage-notification.html',
        controller: function($scope, fetchService) {
          $scope.info = false;
          $scope.critical = false;
          $scope.title = '';
          $scope.message = '';

          fetchService
            .getFetchTVNotification($scope.appName)
            .then(function(notification) {
              if (notification) {
                var startTime = new Date(notification['start_time']),
                  endTime = new Date(notification['end_time']),
                  now = Date.now();
                if (startTime.getTime() > now || now > endTime.getTime()) {
                  return;
                }
              }

              $scope.title = notification.title;
              $scope.message = notification.message;
              $scope.severity = notification.severity;
              $scope.info = notification.severity === 'info';
              $scope.critical = notification.severity === 'danger';
              $scope.blockerNotificationDetected = notification.blocker === 'true';
            });
        }
      };
    });
})(angular);

